export const LOG_IN_SUCCESS = 'LOG_IN_SUCCESS'
export const LOG_OUT = 'LOG_OUT'
export const SEND_SMS = 'SEND_SMS'
export const SMS_SENT = 'SMS_SENT'
export const SET_VIDEO_DATA = 'SET_VIDEO_DATA'
export const ACTIVATE_CODE = 'ACTIVATE_CODE'
export const INVALID_CODE = 'INVALID_CODE'
export const INVALID_PHONE = 'INVALID_PHONE'
export const REGISTERED = 'REGISTERED'
export const COMPLETE = 'COMPLETE'
export const SET_CURRENT_USER = 'SET_CURRENT_USER'
export const SET_USER_PHONE = 'SET_USER_PHONE'
export const DELETE_PHONE_NUMBER = 'DELETE_PHONE_NUMBER'
export const CLEAR_ALL_ERRORS = 'CLEAR_ALL_ERRORS'
export const EMPTY_FIELDS = 'EMPTY_FIELDS'
export const INVALID_AVATAR = 'INVALID_AVATAR'
export const SET_USER_STATUS = 'SET_USER_STATUS'
export const SET_ACTIVATION_CODE = 'SET_ACTIVATION_CODE'



// WEBPACK FOOTER //
// ./src/actions/actionTypes.js